// "Assa" sprites de texto em canvas, uma vez, com cache. Desenhar depois é um drawImage.

import { resolveToken, type Slots } from '../art/palette.js';
import type { PixelSprite } from '../art/types.js';

const cache = new WeakMap<PixelSprite, Map<string, HTMLCanvasElement>>();

export function makeCanvas(w: number, h: number): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, w);
  canvas.height = Math.max(1, h);
  return canvas;
}

export function ctx2d(canvas: HTMLCanvasElement): CanvasRenderingContext2D {
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('canvas sem contexto 2d');
  ctx.imageSmoothingEnabled = false;
  return ctx;
}

/**
 * Canvas do sprite. `slots` + `slotKey` para partes de personagem (o slotKey identifica
 * a combinação de cores no cache). `flip` espelha na horizontal.
 */
export function bake(sprite: PixelSprite, opts: { slots?: Slots; slotKey?: string; flip?: boolean } = {}): HTMLCanvasElement {
  const key = `${opts.slotKey ?? ''}|${opts.flip ? 1 : 0}`;
  let byKey = cache.get(sprite);
  if (!byKey) {
    byKey = new Map();
    cache.set(sprite, byKey);
  }
  const hit = byKey.get(key);
  if (hit) return hit;

  const canvas = makeCanvas(sprite.w, sprite.h);
  const ctx = ctx2d(canvas);
  const colors = new Map<string, string | undefined>();
  for (const [c, token] of Object.entries(sprite.palette)) colors.set(c, resolveToken(token, opts.slots));
  for (let y = 0; y < sprite.rows.length; y++) {
    const row = sprite.rows[y] ?? '';
    for (let x = 0; x < row.length; x++) {
      const c = row[x];
      if (!c || c === '.') continue;
      const color = colors.get(c);
      if (!color) continue;
      ctx.fillStyle = color;
      ctx.fillRect(opts.flip ? sprite.w - 1 - x : x, y, 1, 1);
    }
  }
  byKey.set(key, canvas);
  return canvas;
}
